import { NgModule } from '@angular/core';
import { VisitedLinkDirective } from './visited-link.directive';

@NgModule({
  declarations: [VisitedLinkDirective],
  exports: [VisitedLinkDirective],
})
export class VisitedLinkModule {}
